<span (click)="prompt()">
  <ng-content *ngIf="canPrompt$ | async"></ng-content>
</span>
